import React, { Component } from "react";
import PropTypes from "prop-types";
import Autosuggest from "react-autosuggest";
import "./AutoSuggest.css";

class AutoSuggest extends Component {
  constructor() {
    super();

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      nameSuggestions: [],
      emailSuggestions: [],
    };
  }

  escapeRegexCharacters = str => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  // Teach Autosuggest how to calculate suggestions for any given input value.
  createSuggestionsArray = value => {
    const escapedValue = this.escapeRegexCharacters(value.trim());
    const regex = new RegExp("^" + escapedValue, "i");

    return this.props.members.filter(
      member => regex.test(member.name) || regex.test(member.email)
    );
  };

  // When suggestion is clicked, Autosuggest needs to populate the input
  // based on the clicked suggestion. Teach Autosuggest how to calculate the
  // input value for every given suggestion.
  getSuggestionName = suggestion => {
    return suggestion.name;
  };

  getSuggestionEmail = suggestion => {
    return suggestion.email;
  };

  onNameChange = (event, { newValue }) => {
    this.props.commitNameOrEmailValue("nameValue", newValue);
  };

  onEmailChange = (event, { newValue }) => {
    this.props.commitNameOrEmailValue("emailValue", newValue);
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onNameSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      nameSuggestions: this.createSuggestionsArray(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onNameSuggestionsClearRequested = () => {
    this.setState({
      nameSuggestions: [],
    });
  };

  onNameSuggestionSelected = (event, { suggestion }) => {
    this.props.commitNameOrEmailValue("emailValue", suggestion.email);
  };

  onEmailSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      emailSuggestions: this.createSuggestionsArray(value),
    });
  };

  onEmailSuggestionsClearRequested = () => {
    this.setState({
      emailSuggestions: [],
    });
  };

  onEmailSuggestionSelected = (event, { suggestion }) => {
    this.props.commitNameOrEmailValue("nameValue", suggestion.name);
  };

  renderSuggestion = (suggestion, { query, isHighlighted }) => {
    return (
      <div className={`suggestion highlight-${isHighlighted}`}>
        <div className="display-name">{suggestion.name}</div>
        <div className="display-email">{suggestion.email}</div>
      </div>
    );
  };

  renderSuggestionsContainer = ({ containerProps, children, query }) => {
    return (
      <div {...containerProps}>
        <div className="suggestions-container">
          <div className="children">{children}</div>
        </div>
      </div>
    );
  };

  shouldRenderNameSuggestions = () => {
    if (this.props.emailValue) {
      return false;
    }

    return true;
  };

  shouldRenderEmailSuggestions = () => {
    if (this.props.nameValue) {
      return false;
    }

    return true;
  };

  render() {
    // Autosuggest will pass through all these props to the input.
    const nameInputProps = {
      placeholder: "n a m e", //to trick chrome into not autofilling text. Complimented with a negative letter-spacing
      value: this.props.nameValue,
      onChange: this.onNameChange,
      className: "name-input editable-input",
      autoComplete: "gibberish", //also to trick chrome into not autofilling the field
    };

    const emailInputProps = {
      placeholder: "e m a i l", //to trick chrome into not autofilling text. Complimented with a negative letter-spacing
      value: this.props.emailValue,
      onChange: this.onEmailChange,
      className: "email-input editable-input",
      autoComplete: "gibberish", //To trick chrome into not autofilling the field
    };

    // Finally, render it!
    return (
      <div className="assignee-container">
        <div className="name editable-container">
          <Autosuggest
            suggestions={this.state.nameSuggestions}
            onSuggestionsFetchRequested={this.onNameSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onNameSuggestionsClearRequested}
            onSuggestionSelected={this.onNameSuggestionSelected}
            getSuggestionValue={this.getSuggestionName}
            renderSuggestion={this.renderSuggestion}
            renderSuggestionsContainer={this.renderSuggestionsContainer}
            inputProps={nameInputProps}
            shouldRenderSuggestions={this.shouldRenderNameSuggestions}
          />
        </div>
        <div className="email editable-container">
          <Autosuggest
            suggestions={this.state.emailSuggestions}
            onSuggestionsFetchRequested={this.onEmailSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onEmailSuggestionsClearRequested}
            onSuggestionSelected={this.onEmailSuggestionSelected}
            getSuggestionValue={this.getSuggestionEmail}
            renderSuggestion={this.renderSuggestion}
            renderSuggestionsContainer={this.renderSuggestionsContainer}
            inputProps={emailInputProps}
            shouldRenderSuggestions={this.shouldRenderEmailSuggestions}
          />
        </div>
      </div>
    );
  }
}

AutoSuggest.propTypes = {
  nameValue: PropTypes.string.isRequired,
  emailValue: PropTypes.string.isRequired,
  commitNameOrEmailValue: PropTypes.func.isRequired,
  members: PropTypes.array.isRequired,
  commitNewMember: PropTypes.func.isRequired,
};

export default AutoSuggest;



// WEBPACK FOOTER //
// ./src/components/AutoSuggest.js